/* eslint-disable func-names */
import { logger } from '@ubeeqo/web-utils';

const SegmentsPlugin = {};

SegmentsPlugin.install = (Vue, options) => {
  const vue = Vue;

  vue.create = function (key, version) {
    window.analytics = window.analytics || [];
    if (!window.analytics.initialize) {
      if (window.analytics.invoked) {
        logger.message('SEGMENT SERVICE --> Segment snippet included twice.', 'warning');
      } else {
        this.initEmptyAnalytics();
        this.initFactory();
        this.initMethods();
      }
    }

    const self = this;
    this.instance = new Promise((resolve) => {
      self.load(key, resolve);
    });
    window.analytics.SNIPPET_VERSION = version;
    window.analytics.page();
  };

  vue.initEmptyAnalytics = function () {
    window.analytics.invoked = true;
    window.analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
    ];
  };

  vue.initFactory = function () {
    window.analytics.factory = function (type) {
      return function (...args) {
        const methods = Array.prototype.slice.call(args);
        methods.unshift(type);
        window.analytics.push(methods);
        return window.analytics;
      };
    };
  };

  vue.initMethods = function () {
    window.analytics.methods.forEach((method) => {
      window.analytics[method] = window.analytics.factory(method);
    });
  };

  vue.load = function (key, resolve) {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.onload = () => {
      resolve(window.analytics);
    };
    scriptElement.src = `${document.location.protocol}//cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;
    const scriptParentElement = document.getElementsByTagName('script')[0];
    scriptParentElement.parentNode.insertBefore(scriptElement, scriptParentElement);
  };

  vue.getInstance = function () {
    return this.instance;
  };

  vue.create(options.key, options.version);

  vue.prototype.$segments = {
    trackSegment(name, object = null) {
      if (window.analytics) {
        window.analytics.track(name, object);
      }
    },
    trackGroup(id, object = null) {
      if (window.analytics) {
        window.analytics.group(id, object);
      }
    },
    async trackAnonymousUser() {
      const analytics = await vue.getInstance();
      if (analytics) {
        const anonymousId = analytics.user().anonymousId();
        analytics.identify(anonymousId, {
          anonymousId,
        });
      }
    },
    async visitPage(pageName) {
      const analytics = await vue.getInstance();
      if (analytics) {
        analytics.page(pageName);
      }
    },
  };
};

export default SegmentsPlugin;
